let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("llcfA"), load("bA4nr")]).then(() => parcelRequire('1UxsQ'));